<template>
  <div>
    <base-header type="gradient-rmn" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <solvents-table title="Solvents"></solvents-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SolventsTable from "./Tables/DraggableSolventsTable";
export default {
  name: "solvents",
  components: {
    SolventsTable,
  },
};
</script>
<style></style>
